export var CryptoTransactionType;
(function (CryptoTransactionType) {
    CryptoTransactionType["SEND"] = "SEND";
    CryptoTransactionType["RECEIVE"] = "RECEIVE";
})(CryptoTransactionType || (CryptoTransactionType = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["RECEIVED"] = "RECEIVED";
    TransactionStatus["POSTED_TO_TANGANY"] = "POSTED_TO_TANGANY";
    TransactionStatus["FINALIZED"] = "FINALIZED";
    TransactionStatus["FAILED"] = "FAILED";
})(TransactionStatus || (TransactionStatus = {}));
//# sourceMappingURL=crypto.types.js.map